import w from '@store/window';

const isInViewportPartial = function (el: HTMLElement) {
    if (!window || !document || !document.documentElement) {
        return false;
    }
    const rect = el.getBoundingClientRect();
    // DOMRect { x: 8, y: 8, width: 100, height: 100, top: 8, right: 108, bottom: 108, left: 8 }
    const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
    const windowWidth = screenWidth();

    // http://stackoverflow.com/questions/325933/determine-whether-two-date-ranges-overlap
    const vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);
    const horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0);

    return (vertInView && horInView);
};

const screenWidth = () => {
    if (!window || !document || !document.documentElement) {
        console.warn('window width is zero');
        return 0;
    }

    return window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth
        ;
}

/**
 * Determine the mobile operating system.
 * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
 *
 * @returns {String}
 */
const getMobileOperatingSystem = () => {
    var userAgent = navigator.userAgent || navigator.vendor || w.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
        return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !w.MSStream) {
        return "iOS";
    }

    return null;
}

const mobileOperatingSystem = getMobileOperatingSystem();


export { screenWidth, mobileOperatingSystem };
export default isInViewportPartial;


// WEBPACK FOOTER //
// ./src/utils/ViewPort.tsx